import React from 'react';
import { motion } from 'framer-motion';
import Button from '../common/Button';

const Welcome = ({ onContinue }) => {
  return (
    <motion.div
      className="text-center max-w-2xl mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6 tracking-tight">
        The <span className="text-shimmer">Oikosystem</span>
      </h1>

      <motion.p
        className="text-xl text-oliveGold/70 mb-8 italic font-serif"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        "Be a better human"
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <p className="text-lg text-white/60 mb-12">
          Welcome to a journey of self-discovery and growth, guided by the timeless
          wisdom of the ancients and personalized by modern AI technology
          <br />
          <span className="text-white/40">— created by the AGR team.</span>
        </p>

        <Button onClick={onContinue} size="lg">
          Begin Your Journey
        </Button>
      </motion.div>
    </motion.div>
  );
};

export default Welcome;
